import { FC } from 'react'
import { UserAchievement } from 'src/modules/shared/achievement/models'

import {
  CardSlider,
  CardSliderHeader,
  useShowAchievementOverlay,
} from '@shared'
import { GeneralPopupCard } from '@shared'

import styles from './Achievements.module.scss'

type Props = {
  achievements: UserAchievement[]
}

export const Achievements: FC<Props> = ({ achievements }) => {
  const { showOverlay } = useShowAchievementOverlay()

  const handleCardClick = (card: UserAchievement) => {
    showOverlay({
      title: card.name,
      description: card.description,
      image: card.iconUrl,
      isAnimationImg: true,
    })
  }

  return (
    <div className={styles.container}>
      <CardSlider
        dynamicBullets={false}
        swiperClassName={styles.swiper}
        header={
          <CardSliderHeader title="Achievements" count={achievements.length} />
        }
        cards={achievements.map((achievement) => (
          <GeneralPopupCard
            key={achievement.id}
            image={achievement.iconUrl}
            title={achievement.name}
            onClick={() => handleCardClick(achievement)}
          />
        ))}
      />
    </div>
  )
}
